import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor(private router: Router) { }

  mensaje: string = "";

  ngOnInit() {
    let msg = localStorage.getItem("mensaje")
    switch (msg) {
      case "1":
        this.mensaje = "parece que no tienes permisos.";
        break;

      case "2":
        this.mensaje = "estamos en mantenimiento.";
        break;

      default:
        break;
    }
  }

  close() {
    this.router.navigate(['pages/login']);
    localStorage.setItem('session', '0');
    window.localStorage.clear();
  }

}
